"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOrderIdToBookingReference = void 0;
// Note: duplicated in legacy/source/transformers/transformOrderIdToBookingReference.ts:16
const transformUuidToSixCharUppercaseReference = (uuid) => uuid.slice(0, 6).toUpperCase();
/**
 * WARNING!! Reference returned from this function is not unique! There are multiple duplicates of the same reference across collections in the DB!
 *
 * See: https://app.shortcut.com/daytrip/story/25712/investigate-the-order-references-issue
 *
 * This function is used to get the first six uppercase characters of the uuid to create a reference.
 *
 * @param {string} uuid - The booking uuid to transform
 * @returns {string} first six uppercase characters of the booking uuid
 * @example
 * transformOrderIdToBookingReference('d114a066-eb1f-496b-af43-23f5c233b15b') // returns 'D114A0'
 * */
exports.transformOrderIdToBookingReference = transformUuidToSixCharUppercaseReference;
//# sourceMappingURL=transformOrderIdToBookingReference.js.map